import {
  VacanciesInfo,
  VacancyCommentLine,
  VacancyContactsLine,
  VacancyVideo,
} from '@entities/vacancy';
import { useLoaderData, useRouteLoaderData } from '@shared/lib/routing';
import { Breadcrumbs } from '@shared/ui/breadcrumbs';
import { PageContainer } from '@shared/ui/content-containers';
import { Preloader } from '@shared/ui/preloader';
import { PageTitle } from '@shared/ui/titles';
import { PageBanner, PageCustomText, PageHelmet } from '@widgets/seoPage';
import VacanciesModal from 'frontend/Components/Vacancies/VacanciesModal/VacanciesModal';
import { useTranslation } from 'react-i18next';
import { vacanciesLoader } from '../api';
import { VacancyCardWrapper } from './VacancyCardWrapper';

export function Vacancies() {
  const { t } = useTranslation();
  const {
    country: { main_domain: mainDomain },
    city,
  } = useRouteLoaderData('city-layout');
  const { pageData, loading } =
    useLoaderData<Awaited<ReturnType<typeof vacanciesLoader>>>();

  if (loading) {
    return <Preloader />;
  }

  const vacancies = pageData.vacanciesData.items;
  const firstVacancies = vacancies?.slice(0, 3);
  const lastVacancies = vacancies?.slice(3);

  const listStyles =
    'grid lg:grid-cols-3 gap-7 md:grid-cols-2 sm:grid-cols-1 xs:flex xs:flex-col';

  const title = t('Vacancies.vacanciesTitle');

  return (
    <>
      <PageBanner
        bannerData={pageData.seoPageData.banner}
        mainDomain={mainDomain}
      />
      <PageContainer>
        <PageHelmet
          title={title}
          cityName={city.city_name}
          seo={pageData.seoPageData.seo}
          mainDomain={mainDomain}
          type="article"
        />
        <Breadcrumbs
          links={[
            {
              href: '/vakansii',
              text: title,
            },
          ]}
        />
        <PageTitle isCenterOnMobile>{title}</PageTitle>
        <div className="flex flex-col justify-center gap-8 md:gap-9">
          {!!firstVacancies.length && (
            <div className={listStyles}>
              {firstVacancies.map((vacancy, index) => (
                <VacancyCardWrapper
                  vacancy={vacancy}
                  index={index}
                  vacancies={vacancies}
                  email={city.vacancy_email}
                  key={vacancy.id}
                />
              ))}
            </div>
          )}
          <VacancyCommentLine />
          {!!lastVacancies.length && (
            <div className={listStyles}>
              {lastVacancies.map((vacancy, index) => (
                <VacancyCardWrapper
                  vacancy={vacancy}
                  index={index}
                  vacancies={vacancies}
                  email={city.vacancy_email}
                  key={vacancy.id}
                />
              ))}
            </div>
          )}
        </div>
        <VacanciesInfo />
        <VacancyVideo />
        <VacancyContactsLine vacancyEmail={city.vacancy_email} />
        <VacanciesModal />
        <PageCustomText
          customText={pageData.seoPageData.seo.custom_text}
          mainDomain={mainDomain}
        />
      </PageContainer>
    </>
  );
}
